import { render, staticRenderFns } from "./PersonalPanel.vue?vue&type=template&id=b167b7ec&"
import script from "./PersonalPanel.vue?vue&type=script&lang=js&"
export * from "./PersonalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports